import type { GameModule } from '../../core/contracts'
import {
  INITIAL_LEVEL,
  MAX_LEVEL,
  MIN_LEVEL,
  REFERENCE_RT_MS,
  evaluate,
  generateRound,
} from './logic'
import type { TargetAnswer, TargetRound } from './logic'
import { ReactionTargetView } from './view'

/**
 * Зрительный поиск. В отличие от Stroop, различие по форме,
 * а не по цвету - игра доступна при нарушениях цветовосприятия.
 */
export const reactionTarget: GameModule<TargetRound, TargetAnswer> = {
  id: 'reaction-target',
  titleKey: 'game.reactionTarget',
  hintKey: 'game.reactionTarget.hint',
  discipline: 'attention',
  metric: 'speed-accuracy',
  difficulty: { min: MIN_LEVEL, max: MAX_LEVEL, initial: INITIAL_LEVEL },
  roundsPerSession: 4,
  referenceRtMs: REFERENCE_RT_MS,
  generateRound,
  evaluate,
  View: ReactionTargetView,
}

export * from './logic'
